export enum EntityTypes {
  PubliclyTradedCompany = 'PUBLIC_PROFIT',
  PrivateCompany = 'PRIVATE_PROFIT',
  NonProfitOrganization = 'NON_PROFIT',
  Government = 'GOVERNMENT',
  SoleProprietor = 'SOLE_PROPRIETOR',
}
